module.exports = __webpack_public_path__ + "img/20200213161644QQ截图20200212155322.dedede15.png";